const Blank = {
    view() {
        return null;
    },
};

export default Blank;
